import * as yup from 'yup';

export const getIPConsultsCOMFilterSchema = yup.object().shape({
  // domains: yup.array().of(yup.string()),
  fieldsOfActivity: yup.array().of(yup.string()),
});
